<template>
    <div v-show="$store.state.show_navbar == true">
        <div v-if="movil_login == true" class="navbar navbar-expand-lg navbar-light bg-light">
            <div class="d-flex justify-content-between">
                <div>
                    <a><h5 class="float-left mt-3" style="color: grey;" data-toggle="modal" data-target="#menu_">MENÚ</h5></a>
                </div>
                <div>
                    <router-link to="/inicio">
                        <a id="iper_logo_navbar_movil" @click="fondo_naranja();" aria-controls="home" aria-selected="true"><img class="pb-0 mb-0 mt-3" src="img/fondos/iper-logo-color.png" alt="logo-color"/></a>
                    </router-link>
                </div>
                <div>
                    <a class="far fa-question-circle fa-2x float-right mt-3" style="color: #ee8813;" data-toggle="modal" data-target="#modalAyudaMovil"></a>
                </div>
            </div>            
        </div>
        <div v-else>
        </div>
    
        <!-- MODAL MENÚ -->
        <div class="modal fade m-0 p-0 border-0" style="width: 100%;" id="menu_" data-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered m-0 p-0" style="width: 100%">
                <div class="modal-content p-0 m-0">
                    <div class="modal-header border-bottom-0">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-3"><br><br><br><br>     
                        <img src="img/fondos/fondo_menú.jpg" alt="logo-color" class="img_menu"/>     
                        <router-link to="/registro_cliente" class="textoEncima">
                            <h5 class="float-right" style="color: white; text-align: center;" @click="fondo_blanco_naranja();cerrar_menu()">Administración</h5>
                        </router-link>
                        <router-link to="/matriz_peligro"  class="texto-encima1">
                            <h5 class="float-right" style="color: white; text-align: center;" @click="cerrar_menu();fondo_blanco();" >Matriz Peligro</h5>
                        </router-link>
                        <router-link to="/lista_clientes"  class="texto-encima2">
                            <h5 class="float-right" style="color: white;" @click="cerrar_menu();fondo_blanco();">Lista Centro de Trabajo</h5>
                        </router-link>
                        <router-link to="/querys"  class="texto-encima3">
                            <h5 class="float-right" style="color: white;" @click="cerrar_menu();fondo_blanco();">Consulta</h5>
                        </router-link>
                    </div><br><br><br><br>   
                </div>
            </div>
        </div>

        <!-- MODAL AYUDA VERSIÓN MÓVIL -->
        <div class="modal fade m-0 p-0 border-0" style="width: 100%;" id="modalAyudaMovil" data-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered m-0 p-0" style="width: 100%">
                <div class="modal-content p-0 m-0">
                    <div class="modal-header border-bottom-0">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-3 mr-0 pr-0 modal-menu-vm"><br><br><br><br>     
                        <img src="img/fondos/menu_peligros.png" alt="logo-color" class="img_menu_m mr-0 pr-0"/>
                        <div class="textoEncima0_m">
                            <a @click="modalIntroduccion()" data-toggle="modal" data-target="#modalIntroduccion"><h5 style="color: white; text-align: center;">Introducción</h5></a>
                        </div>
                        <div class="textoEncima_m">
                            <a @click="modalPeligroBiologico()" data-toggle="modal" data-target="#modalPeligroBiologico"><h5 style="color: white; text-align: center;">Peligro Biológico</h5></a>
                        </div>
                        <div class="texto-encima1_m">
                            <a @click="modalPeligroFisico()" data-toggle="modal" data-target="#modalPeligroFisico"><h5 style="color: white; text-align: center;">Peligro Físico</h5></a>
                        </div>
                        <div class="texto-encima2_m">
                            <a @click="modalPeligroQuimico()" data-toggle="modal" data-target="#modalPeligroQuimico"><h5 style="color: white;">Peligro Químico</h5></a>
                        </div>
                        <div class="texto-encima3_m">
                            <a @click="modalPeligroPsico()" data-toggle="modal" data-target="#modalPeligroPsico"><h5 style="color: white;">Peligro Psicosocial</h5></a>
                        </div>
                        <div class="texto-encima4_m">
                            <a @click="modalPeligroBiomecanico()" data-toggle="modal" data-target="#modalPeligroBiomecanico"><h5 style="color: white;">Peligro Biomecánico</h5></a>
                        </div>
                        <div class="texto-encima5_m">
                            <a @click="modalPeligroPcs()" data-toggle="modal" data-target="#modalPeligroPcs"><h5 style="color: white; text-align: right;">Peligro por Condiciones<br> de Seguridad</h5></a>
                        </div>
                    </div><br><br><br><br>
                </div>
            </div>
        </div>

        <!-- MODAL AYUDA VERSIÓN MÓVIL -->
        <div class="modal fade m-0 p-0 border-0" style="width: 100%;" id="modalIntroduccion" data-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable m-0 p-0 modal-full-Size">
                <div class="modal-content p-0 m-0">
                    <div class="modal-header border-bottom-0">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mr-0 pr-0 modal-menu-vm">
                        <div class="card v-movil-divs">
                            <div class="card-body v-movil-divs mt-0 pt-0">

                                <div id="carouselControlsBiologico" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">

                                        <div class="carousel-item active pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Introducción</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            La herramienta tecnológica IPER “Identificación de Peligros y Evaluación de Riesgos” 
                                                            está diseñada para facilitar a los profesionales del área de Seguridad y Salud en el Trabajo, 
                                                            en la elaboración de la matriz de peligros de cualquier clase de organización utilizando la 
                                                            metodología GTC-45 (Guía para la identificación de los peligros y la valoración de los riesgos en seguridad y salud en el trabajo).
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Con nuestra App IPER by Sofu, usted:
                                                            <ul>
                                                                <li>
                                                                    Administra los procesos, peligros, efectos posibles, controles existentes y medidas de intervención de la organización.
                                                                </li>
                                                                <li>
                                                                    Administra los usuarios y sus privilegios con acceso a la información dentro de la App IPER by Sofu, 
                                                                    por acciones, clientes, centros de trabajo y/o áreas geográficas.
                                                                </li>
                                                                <li>
                                                                    Identificar los peligros de cada uno de los procesos de la organización de forma fácil e intuitiva desde su PC 
                                                                    o en su celular Móvil, además, de adjuntar registro fotográfico.
                                                                </li>
                                                                <li>
                                                                    Puede priorizar los riesgos de acuerdo con el nivel de riesgo de una matriz de peligros o la combinación de varias matrices, 
                                                                    facilitando la toma de decisiones de índole gerencial.
                                                                </li>
                                                                <li>
                                                                	Asegura la información de su organización.
                                                                </li>
                                                            </ul>
                                                        </p>
                                                                                                                
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        

                                    </div>
                                    <a class="carousel-control-prev" href="#carouselControlsBiologico" role="button" data-slide="prev">
                                        <span class="carousel-control-prev-icon text-dark" aria-hidden="true"></span>
                                        <span class="sr-only">Anterior</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carouselControlsBiologico" role="button" data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Siguiente</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL AYUDA VERSIÓN MÓVIL -->
        <div class="modal fade m-0 p-0 border-0" style="width: 100%;" id="modalPeligroBiologico" data-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable m-0 p-0 modal-full-Size">
                <div class="modal-content p-0 m-0">
                    <div class="modal-header border-bottom-0">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mr-0 pr-0 modal-menu-vm">
                        <div class="card v-movil-divs">
                            <div class="card-body v-movil-divs mt-0 pt-0">

                                <div id="carouselControlsBiologico" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">

                                        <div class="carousel-item active pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Peligro Biológico</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            El riesgo biológico consiste en la presencia de un organismo, o la sustancia derivada de un organismo, que plantea, sobre todo, 
                                                            una amenaza a la salud humana (una contaminación biológica). Esto puede incluir los residuos sanitarios, muestras de un microorganismo, 
                                                            virus o toxina de una fuente biológica que puede resultar patógena. Puede también incluir las sustancias dañinas a los animales y 
                                                            otros seres vivos.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Las actividades laborales donde existe la mayor posibilidad de encontrar trabajadores expuestos a los riesgos biológicos son: Entidades de salud, 
                                                            laboratorios clínicos, biológicos, cría y manejo de animales, manejo de pieles y otros productos animales, procesamiento de carnes, 
                                                            servicios funerarios, manipulación de residuos entre otros.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Los principales mecanismos por los que un microorganismo penetra en un individuo son inhalación, ingestión y contacto dérmico.
                                                        </p>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Virus</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Agente infeccioso microscópico que solo puede multiplicarse dentro de las células de otros organismos.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Los virus infectan todos los tipos de organismos, desde animales y plantas, hasta bacterias y arqueas.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Ejemplos de enfermedades humanas comunes provocadas por virus incluyen el resfriado, la gripe, 
                                                            la varicela y el herpes simple. Así como enfermedades graves tales como el ébola, el sida, 
                                                            la gripe aviar y el SARS son causadas por virus.
                                                        </p>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Bacterias</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Microorganismos que presentan un tamaño de unos pocos micrómetros y diversas formas incluyendo filamentos, 
                                                            esferas (cocos), barras (bacilos), sacacorchos (vibrios) y hélices (espirilos).
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Solo una pequeña fracción de las bacterias causan enfermedades en los seres humanos. 
                                                            Son una de las principales causas de enfermedad y mortalidad humana, causando infecciones tales como el tétanos, 
                                                            la fiebre tifoidea, la difteria, la sífilis, el cólera, intoxicaciones alimentarias, la lepra y la tuberculosis.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Hongos</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Son formas complejas de vida que presentan una estructura vegetal. 
                                                            Su hábitat natural es el suelo, pero algunos son parásitos tanto de animales como de vegetales, 
                                                            ya que no pueden sintetizar proteínas por sí solos. Producen principalmente enfermedades micóticas (pie de atleta), 
                                                            asma, etc. Se manifiestan principalmente a través de la piel.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Parásitos</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Tipo de simbiosis en la que existe una estrecha relación en la cual uno de los participantes, 
                                                            (el parásito o huésped) depende del otro (hospedador o anfitrión) y obtiene algún beneficio; 
                                                            lo cual implica daño para el anfitrión.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Ocasionan enfermedades como la malaria, tripanosomiasis africana, 
                                                            giardiasis, esquistosomiasis, fascioliasis entre otras.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Rackettsias</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Pequeñas bacterias del filo de las proteobacterias.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Según la distribución de las rickettsias se puede producir neumonitis intersticial, 
                                                            miopericarditis, lesiones vasculíticas cutáneas, meningitis linfocitaria, así como afectación hepática, 
                                                            renal y gastrointestinal.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Picaduras</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Las picaduras son pequeñas heridas punzantes producidas principalmente por insectos, 
                                                            artrópodos y animales marinos a través de las cuales inyectan sustancias tóxicas que actúan localmente y 
                                                            en forma sistemática (en todo el cuerpo) de acuerdo con la clase de agente causante, la cantidad de tóxico y la respuesta orgánica.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Pueden producir desde reacciones alérgicas hasta la muerte.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Mordedura</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Situación generada por animales como serpientes, perros, gatos y monos entre otros. 
                                                            El problema de este tipo de lesiones no es en si la herida que provocan, 
                                                            sino la grave infección que pueden desencadenar.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Las consecuencias para la salud humana dependerán de la especie animal de que se trate y su estado de salud, 
                                                            el tamaño y el estado de salud de la víctima de la mordedura, 
                                                            y la capacidad de acceder a la atención sanitaria adecuada.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Fluidos o excrementos</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Aquellos materiales de origen humano, animal o vegetal consistentes entre otras cosas, 
                                                            en excretas, secreciones, sangre y sus componentes, tejidos y líquidos tisulares, 
                                                            que contienen microorganismos incluidas las bacterias, virus, parásitos, hongos entre otros.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Las consecuencias para la salud humana dependen de los microorganismos que contengan el fluido o 
                                                            el excremento pudiendo ocasionar hasta la muerte.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <a class="carousel-control-prev" href="#carouselControlsBiologico" role="button" data-slide="prev">
                                        <span class="carousel-control-prev-icon text-dark" aria-hidden="true"></span>
                                        <span class="sr-only">Anterior</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carouselControlsBiologico" role="button" data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Siguiente</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL AYUDA VERSIÓN MÓVIL PELIGRO FÍSICO -->
        <div class="modal fade m-0 p-0 border-0" style="width: 100%;" id="modalPeligroFisico" data-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable m-0 p-0 modal-full-Size">
                <div class="modal-content p-0 m-0">
                    <div class="modal-header border-bottom-0">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mr-0 pr-0 modal-menu-vm">
                        <div class="card v-movil-divs">
                            <div class="card-body v-movil-divs mt-0 pt-0">

                                <div id="carouselControlsFisico" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">

                                        <div class="carousel-item active pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Peligro Físico</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Los factores de riesgo físico se refieren a todos aquellos factores ambientales que dependen 
                                                            de las propiedades físicas de los cuerpos, tales como carga física, ruido, iluminación, 
                                                            radiación ionizante, radiación no ionizante, temperaturas extremas y vibración, 
                                                            que actúan sobre los tejidos y órganos del cuerpo del trabajador y que pueden producir efectos nocivos, 
                                                            de acuerdo con la intensidad y tiempo de exposición al mismos.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Ruido</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            El sonido es producido por la vibración de cuerpos o moléculas y dependiendo de la intensidad, 
                                                            la frecuencia o el timbre se pueden convertir en ruido generalmente molesto. Esta Presión sonora 
                                                            es medida en decibeles y es emitida por maquinas, equipos o elementos del entorno.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Ruido de impacto</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Es aquel en el que se presentan variaciones rápidas de un nivel de presión sonora en intervalos de tiempo menores. 
                                                            Ejemplo: el producido por los estampadores.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Ruido intermitente</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Es aquel en el cual se presentan subidas bruscas y repentinas de la intensidad sonora en forma periódica. 
                                                            Ejemplo: el accionar un taladro.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Ruido continuo</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Es aquel cuyos niveles de presión sonora no presenta oscilaciones y se mantiene relativamente constantes a través del tiempo. 
                                                            Ejemplo: ruido de un motor eléctrico.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Iluminación</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Cantidad de luminosidad presente en el sitio de trabajo de los colaboradores cuya finalidad 
                                                            es facilitar la visualización de los objetos y el área de trabajo. A mayor precisión requerida, 
                                                            mayor necesidad de iluminación.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Fatiga visual, molestias oculares, pesadez de ojos, picores, necesidad de frotarse los ojos, somnolencia.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Trastornos visuales.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Borrosidad, disminución de la capacidad visual.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Fatiga mental cefaleas, vértigos, ansiedad. 
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Deslumbramientos.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Vibración</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Propagación de ondas elásticas, que producen deformaciones y 
                                                            tensiones sobre un medio continuo o punto de equilibrio.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Se genera en presencia de máquinas en movimiento constante o con el uso de herramientas de perforación como taladros.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Dependiendo de la frecuencia del movimiento oscilatorio, y de su intensidad, 
                                                            la vibración puede causar sensaciones muy diversas que van desde el simple disconfort 
                                                            hasta alteraciones graves de la salud, pasando por la interferencia de la labor de ciertas 
                                                            tareas como la lectura, perdida de presión al ejecutar movimientos, o perdida de rendimiento debido a la fatiga.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Temperaturas Extremas Calor</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Se refiere a los cambios de temperatura extremas (muy alta o baja) que se generan en el 
                                                            entorno del colaborador los cuales se manifiestan en el aire y en los cuerpos en forma de calor, 
                                                            en una gradación que fluctúa entre lo caliente y lo frio.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Temperaturas Extremas Frío</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Malestar general, disminución de destreza manual, congelación de los miembros, 
                                                            comportamiento extravagante, muerte por falla cardiaca.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Presión atmosférica</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            La presión atmosférica es la fuerza por unidad de superficie que ejerce el aire sobre la superficie terrestre. 
                                                            A grandes o bajas alturas respecto al nivel del mar se pueden producir efectos nocivos en la salud de los colaboradores.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Las altas o bajas presiones atmosféricas pueden afectar el oído, los senos paranasales, y los pulmones. 
                                                            Enfermedades típicas ocasionadas por la presión atmosférica son la barotitis, la barosinusitis y algunas afecciones pulmonares.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Radiaciones ionizantes</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            La radiación ionizante es un tipo de energía liberada por los 
                                                            átomos en forma de ondas electromagnéticas o partículas.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            La mayor exposición humana a la radiación proviene de fuentes artificiales que van desde 
                                                            la generación de energía nuclear hasta el uso médico de la radiación para fines diagnósticos o terapéuticos.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Las dosis bajas de radiación ionizante pueden aumentar el riesgo de efectos a largo plazo, tales como el cáncer.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Cuando las dosis de radiación superan determinados niveles pueden tener efectos agudos en la salud, 
                                                            tales como quemaduras cutáneas o síndrome de irradiación aguda.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Radiación no ionizante</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Se llama radiación no ionizante a toda energía en forma de ondas que se propagan a través del espacio.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Algunos ejemplos de radiación No Ionizante son la radiación ultravioleta, 
                                                            la luz visible, la radiación infrarroja, los campos de radiofrecuencias y microondas, 
                                                            los campos de frecuencias extremadamente bajas y los campos eléctricos y magnéticos estáticos.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Producen efectos biológicos, como calentamiento, alteración de las reacciones químicas o 
                                                            inducción de corrientes eléctricas en los tejidos y las células. La exposición continua puede causar cáncer.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <a class="carousel-control-prev" href="#carouselControlsFisico" role="button" data-slide="prev">
                                        <span class="carousel-control-prev-icon text-dark" aria-hidden="true"></span>
                                        <span class="sr-only">Anterior</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carouselControlsFisico" role="button" data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Siguiente</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL AYUDA VERSIÓN MÓVIL PELIGRO QUÍMICO -->
        <div class="modal fade m-0 p-0 border-0" style="width: 100%;" id="modalPeligroQuimico" data-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable m-0 p-0 modal-full-Size">
                <div class="modal-content p-0 m-0">
                    <div class="modal-header border-bottom-0">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mr-0 pr-0 modal-menu-vm">
                        <div class="card v-movil-divs">
                            <div class="card-body v-movil-divs mt-0 pt-0">

                                <div id="carouselControlsQuimico" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">

                                        <div class="carousel-item active pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Peligro Químico</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Riesgo producido por una exposición no controlada a agentes químicos la cual puede producir efectos 
                                                            agudos o crónicos y la aparición de enfermedades. Entran en contacto con el organismo, bien sea por inhalación, absorción o ingestión.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Polvos orgánicos e inorgánicos</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Material sólido fino, orgánico o inorgánico, capaz de producir enfermedades que se 
                                                            agrupan bajo la denominación genérica de neumoconiosis.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Partículas tóxicas</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Intoxicación aguda o crónica.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Polvos Alérgicos</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Asma, fiebre, dermatitis entre otras.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Polvos Inertes</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Disminución de la capacidad respiratoria.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Polvos Fibrógenos</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Fibrosis pulmonar o neumoconiosis.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Fibras</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Partículas alongadas cuya longitud es varias veces superior al diámetro. 
                                                            Las fibras respirables representan un riesgo para el sistema respiratorio.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Producen desde problemas respiratorios hasta problemas cancerígenos.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Líquidos (Nieblas y Rocíos)</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Gotas menudas que flotan en el aire las cuales han sido formadas por una condensación 
                                                            del estado gaseoso disgregando un líquido o por atomización, rocío o espumamiento.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Las consecuencias dependen del químico.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Gases y vapores</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Sustancias en forma gaseosa que normalmente se encuentran en estado líquido o 
                                                            sólido y que pueden ser tornadas a su estado original mediante un aumento de presión o disminución de la temperatura.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Las consecuencias dependen del químico.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Humos Metálicos y no Metálicos</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Aerosoles que se forman por condensación de vapores de sustancias que son 
                                                            sólidas a temperatura y presión ordinaria. Uno de los humos más comunes es el producido por la fundición de metales.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Las consecuencias dependen del químico.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Material Particulado</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Mezcla heterogénea de partículas de diferentes tamaños y composición química. 
                                                            Es considerado como uno de los contaminantes del aire más importantes en términos 
                                                            de sus posibles efectos sobre la salud de las personas.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Afecciones respiratorias y cardiacas.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <a class="carousel-control-prev" href="#carouselControlsQuimico" role="button" data-slide="prev">
                                        <span class="carousel-control-prev-icon text-dark" aria-hidden="true"></span>
                                        <span class="sr-only">Anterior</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carouselControlsQuimico" role="button" data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Siguiente</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL AYUDA VERSIÓN MÓVIL PELIGRO PSICOSOCIAL -->
        <div class="modal fade m-0 p-0 border-0" style="width: 100%;" id="modalPeligroPsico" data-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable m-0 p-0 modal-full-Size">
                <div class="modal-content p-0 m-0">
                    <div class="modal-header border-bottom-0">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mr-0 pr-0 modal-menu-vm">
                        <div class="card v-movil-divs">
                            <div class="card-body v-movil-divs mt-0 pt-0">

                                <div id="carouselControlsPsico" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">

                                        <div class="carousel-item active pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Peligro Psicosocial</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Riesgos relacionados con el medio ambiente laboral, la satisfacción en el trabajo, 
                                                            las capacidades, necesidades y expectativas del trabajador, sus costumbres, 
                                                            sus condiciones personales y muchos otros, que pueden repercutir en la salud y el rendimiento del trabajador.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Los riesgos psicosociales perjudican la salud de los trabajadores y trabajadoras, 
                                                            causando estrés y a largo plazo enfermedades cardiovasculares, respiratorias, 
                                                            inmunitarias, gastrointestinales, dermatológicas, endocrinológicas, musculoesqueléticas y mentales. 
                                                            Son consecuencia de unas malas condiciones de trabajo, concretamente de una deficiente organización del trabajo.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Gestión organizacional</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Aspectos propios de la administración del recurso humano como el estilo de mando, 
                                                            las modalidades de pago y de contratación, la participación, el acceso a actividades 
                                                            de inducción y capacitación, los servicios de bienestar social, los mecanismos de evaluación 
                                                            del desempeño y las estrategias para el manejo de los cambios que afecten a las personas, entre otros.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Características de la Organización del Trabajo</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Formas de comunicación, tecnología, modalidad de organización del trabajo y demandas cualitativas y cuantitativas de la labor.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Características del Grupo Social de Trabajo</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Clima de relaciones, cohesión y calidad de las interacciones, así como el trabajo en equipo.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Condiciones de la Tarea</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Disminución de la capacidad respiratoria.Demandas de carga mental (velocidad, 
                                                            complejidad, atención, minuciosidad, variedad y apremio de tiempo); 
                                                            el contenido mismo de la tarea que se define a través del nivel de responsabilidad directo 
                                                            (por bienes, por la seguridad de otros, por información confidencial, 
                                                            por vida y salud de otros, por dirección y por resultados); las demandas emocionales 
                                                            (por atención de clientes); especificación de los sistemas de control y definición de roles.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Interfaz Persona Tarea</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Pertinencia del conocimiento y habilidades que tiene la persona en relación con las 
                                                            demandas de la tarea, los niveles de iniciativa y autonomía que le son permitidos 
                                                            y el reconocimiento, así como la identificación de la persona con la tarea y con la organización.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Jornada de Trabajo</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Información detallada por áreas y cargos de la empresa sobre duración de la jornada laboral; 
                                                            existencia o ausencia de pausas durante la jornada, diferentes al tiempo para las comidas; 
                                                            trabajo nocturno; tipo y frecuencia de rotación de los turnos; número y frecuencia de las 
                                                            horas extras mensuales y duración y frecuencia de los descansos semanales.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <a class="carousel-control-prev" href="#carouselControlsPsico" role="button" data-slide="prev">
                                        <span class="carousel-control-prev-icon text-dark" aria-hidden="true"></span>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carouselControlsPsico" role="button" data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL AYUDA VERSIÓN MÓVIL PELIGRO BIOMECÁNICO -->
        <div class="modal fade m-0 p-0 border-0" style="width: 100%;" id="modalPeligroBiomecanico" data-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable m-0 p-0 modal-full-Size">
                <div class="modal-content p-0 m-0">
                    <div class="modal-header border-bottom-0">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mr-0 pr-0 modal-menu-vm">
                        <div class="card v-movil-divs">
                            <div class="card-body v-movil-divs mt-0 pt-0">

                                <div id="carouselControlsBiomecanico" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">

                                        <div class="carousel-item active pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Peligro Biomecánico</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Involucra todos aquellos agentes o situaciones que tienen que ver con la adecuación del trabajo, 
                                                            o los elementos de trabajo a la fisonomía humana.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Postura Prolongada</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Mantenimiento de una misma postura principal a lo largo del 75% de la jornada laboral. (Labores de digitación).
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Postura Mantenida</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Se refiere al mantenimiento de una misma postura sedente o bípeda durante periodo de 2 o más horas, 
                                                            (Posturas de cuclillas o de rodillas).
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Postura Forzada</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Posición de trabajo que implica que el cuerpo deje de estar en una posición de confort para pasar 
                                                            a una posición forzada que puede implicar hiperextensiones, hiperflexiones y/o hiperrotaciones.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Postura Antigravitacional</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Posicionamiento del tronco o de las extremidades en contra de la gravedad.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Esfuerzo</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            El esfuerzo que el trabajador tiene que realizar para desarrollar la actividad laboral 
                                                            se denomina “carga de trabajo”. Cuando la carga de trabajo sobrepasa la 
                                                            capacidad del trabajador se pueden producir sobrecargas y fatiga.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Lesiones musculo esqueléticas.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Movimiento Repetitivo</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Grupo de movimientos continuos mantenidos durante un trabajo que implica la acción conjunta de los músculos, 
                                                            los huesos, las articulaciones y los nervios de una parte del cuerpo y provoca en esta misma zona fatiga muscular, 
                                                            sobrecarga, dolor y, por último, lesión.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Lesiones musculo esqueléticas.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Manipulación Manual de Cargas</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Toda manipulación que incluya levantamiento, descenso, transporte, tracción o empuje de objetos pesados.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Lesiones musculo esqueléticas.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <a class="carousel-control-prev" href="#carouselControlsBiomecanico" role="button" data-slide="prev">
                                        <span class="carousel-control-prev-icon text-dark" aria-hidden="true"></span>
                                        <span class="sr-only">Anterior</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carouselControlsBiomecanico" role="button" data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Siguiente</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL AYUDA VERSIÓN MÓVIL PELIGRO POR CONDICIONES DE SEGURIDAD -->
        <div class="modal fade m-0 p-0 border-0" style="width: 100%;" id="modalPeligroPcs" data-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable m-0 p-0 modal-full-Size">
                <div class="modal-content p-0 m-0">
                    <div class="modal-header border-bottom-0">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mr-0 pr-0 modal-menu-vm">
                        <div class="card v-movil-divs">
                            <div class="card-body v-movil-divs mt-0 pt-0">

                                <div id="carouselControlsPsc" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">

                                        <div class="carousel-item active pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Peligros por Condiciones de Seguridad</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Son todos aquellos factores asociados a la labor que pueden dar lugar a situaciones indeseables 
                                                            y que pueden por tanto causar daños a los trabajadores. Debidas a las máquinas y los equipos, 
                                                            las herramientas, los espacios de trabajo, la manipulación y el transporte, los sistemas eléctricos entre otros.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Mecánico</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Contempla todos los factores presentes en objetos, máquinas, equipos, herramientas, 
                                                            que pueden ocasionar accidentes laborales, por falta de mantenimiento preventivo y/o correctivo, 
                                                            carencia de guardas de seguridad en el sistema de transmisión de fuerza, punto de operación y 
                                                            partes móviles y salientes, falta de herramientas de trabajo y elementos de protección personal.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Laceraciones, aplastamientos, amputaciones, ingreso de cuerpos extraños a la vía ocular, 
                                                            traumas, quemaduras y en ciertos casos la muerte.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Eléctrico</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Se refiere a los sistemas eléctricos de las máquinas, equipos, 
                                                            herramientas e instalaciones locativas en general, que conducen o generan energía eléctrica.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Pueden provocar, entre otras lesiones, quemaduras, choque, fibrilación ventricular, 
                                                            según sea la intensidad de la corriente y el tiempo de contacto.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Locativo</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Se refiere a las características de diseño, construcción, mantenimiento y deterioro de las instalaciones 
                                                            locativas las cuales pueden ocasionar lesiones a los trabajadores o incomodidades para desarrollar la labor.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Tropezones, resbalones, caídas golpes por choque con equipos, escritorios, máquinas y otros, cortaduras, 
                                                            infecciones, alergias, picaduras, etc., por falta de orden y aseo.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Tecnológico</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                        Es la probabilidad de que un objeto, material o proceso peligroso, una sustancia tóxica o 
                                                        peligrosa o bien un fenómeno debido a la interacción de estos, ocasione un número determinado de 
                                                        consecuencias a la salud, la economía, el medio ambiente y el desarrollo integral de un sistema.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Accidente de Tránsito</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Situaciones que pueden generar lesiones a las personas en las que se ven involucrados vehículos.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Accidentes de trabajo con potencial de causar la muerte de la persona.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Públicos</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Factor de riesgo derivado de situaciones de agresión intencional de seres humanos contra seres humanos, 
                                                            contra intereses privados de las personas, ó, contra algunas comunidades (actos delictivos), 
                                                            y en los que se vean involucrados trabajadores de manera directa o indirecta, y que produzcan lesiones 
                                                            generando una incapacidad temporal o permanente.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            El riesgo público considera situaciones como robos, atracos, asaltos, atentados, de orden público etc.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Accidentes de trabajo con potencial de causar la muerte de la persona.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Trabajo en Alturas</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Se refiere a los riesgos que genera toda actividad que se realice a más de un metro con cincuenta centímetros (1,5m) 
                                                            del nivel del suelo ya sea negativo o positivo.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Accidentes de trabajo con potencial de causar la muerte de la persona.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item pt-0 mt-0">
                                            <div class="card v-movil-divs">
                                                <h3 style="color: #e8640c;font-weight: bold;text-align: center;">Espacios Confinados</h3>
                                                <div class="card-body bg-light v-movil-divs">
                                                    <div class="card-text">
                                                        <p style="text-align: justify">
                                                            Se refiere a los riesgos asociados a la labor que se realiza en un espacio que por su diseño tiene 
                                                            un número limitado de aberturas de entrada y salida, cuenta con una ventilación natural desfavorable 
                                                            que podría contener o generar peligrosos contaminantes del aire, y no está destinado para una presencia continua de empleados.
                                                        </p>
                                                        <p style="text-align: justify">
                                                            Accidentes de trabajo con potencial de causar la muerte de la persona.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <a class="carousel-control-prev" href="#carouselControlsPsc" role="button" data-slide="prev">
                                        <span class="carousel-control-prev-icon text-dark" aria-hidden="true"></span>
                                        <span class="sr-only">Anterior</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carouselControlsPsc" role="button" data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Siguiente</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="pc_login == true">
            <nav class="navbar navbar-expand-lg navbar-light bg-light">       
                <router-link to="/inicio">
                    <a id="iper_logo_navbar" @click="fondo_naranja();" data-toggle="pill" href="#" role="tab" aria-controls="home" aria-selected="true">
                        <img src="img/fondos/iper-logo-color.png" alt="logo-color" class='img_inicio ml-4'/></a>
                </router-link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarText">
                    <ul class="navbar-nav mr-auto">                
                        <!-- REDIRECCIONAMIENTO - MÓDULO ADMINSTRACIÓN -->
                        <li class="nav-item active">
                            <router-link to="/clientes">
                                <a @click="fondo_blanco_naranja();" class="nav-link-navbar ml-5 tamaño_letra">
                                    <span>Administración</span>
                                </a>
                            </router-link>
                        </li>    
                        <li class="nav-item">
                            <router-link to="/registro_centro_trabajo">
                                <a @click="fondo_blanco();" class="nav-link-navbar ml-3 tamaño_letra">
                                    <span class=''>Matriz Peligro</span>
                                </a>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/lista_clientes">
                                <a @click="fondo_blanco();" class="nav-link-navbar ml-3 tamaño_letra">
                                    <span class=''>Lista Centro Trabajo</span>
                                </a>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/querys">
                                <a @click="fondo_blanco();" class="nav-link-navbar ml-3 tamaño_letra">
                                    <span class=''>Consulta</span>
                                </a>
                            </router-link>
                        </li>
                        <!-- <li class="nav-item">
                            <router-link to="/inicio">
                                <a @click="fondo_naranja(); csv()" class="nav-link-navbar ml-3 tamaño_letra">
                                    <span onclick="window.open('IPER.csv')">Formato .CSV</span>
                                </a>
                            </router-link>
                        </li> -->
                    </ul>   
                    <span class="navbar-text tamaño_letra">
                                {{$store.state.version}}
                    </span>&nbsp;&nbsp;&nbsp;
                     <!--<a class="far fa-question-circle fa-lg" style="color: #ee8813; cursor: pointer;" data-toggle="modal" data-target="#modalAyuda"></a>   -->
                    <Traduccion class="mr-2 mt-2" />
                    <router-link to="/novedades">
                        <i class="far fa-newspaper fa-lg mt-2" style="color: #ee8813; cursor: pointer;"></i>
                    </router-link>
                    <div class="dropleft">
                        <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img src="img/iconos/iser.png" style="cursor: pointer; width: 35px"/>
                        </a>
                        <div class="dropdown-menu">                            
                            <a class="dropdown-item" type="button" data-toggle="modal" role="tab" aria-selected="false" data-target="#modal_perfil" @click="consultar()">Perfil</a>                            
                            <a class="dropdown-item" @click="cerrarsesion()" type="button" id="btn_logout_navbar">Cerrar Sesión</a>
                        </div>
                    </div>
                </div>
            </nav>
        </div>

        <!-- MODAL DESCRIPCIONES -->
        <div class="modal fade" id="modalAyuda" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-full-Size">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 d-flex justify-content-center">
                        <button type="button" class="btn m-1 bg-light rounded-pill" data-dismiss="modal" aria-label="Close">
                            <span style="color:#ee8813; font-weight: bold; text-align: center; font-size: 2rem" aria-hidden="true">X</span>
                        </button>
                    </div>
                    <div class="modal-body p-0 m-0 modal-background">

                        <nav>
                            <div class="nav nav-tabs-vm nav-pills flex-column flex-sm-row" id="nav-tab" role="tablist">
                                <a class="flex-sm-fill text-sm-center nav-link-vm active" id="nav-p-bio-tab" data-toggle="tab" href="#nav-p-bio" role="tab" aria-controls="nav-p-bio" aria-selected="true">Peligro Biológico</a>
                                <a class="flex-sm-fill text-sm-center nav-link-vm" id="nav-p-fisico-tab" data-toggle="tab" href="#nav-p-fisico" role="tab" aria-controls="nav-p-fisico" aria-selected="false">Peligro Físico</a>
                                <a class="flex-sm-fill text-sm-center nav-link-vm" id="nav-p-quimico-tab" data-toggle="tab" href="#nav-p-quimico" role="tab" aria-controls="nav-p-quimico" aria-selected="false">Peligro Químico</a>
                                <a class="flex-sm-fill text-sm-center nav-link-vm" id="nav-p-psico-tab" data-toggle="tab" href="#nav-p-psico" role="tab" aria-controls="nav-p-psico" aria-selected="false">Peligro Psicosocial</a>
                                <a class="flex-sm-fill text-sm-center nav-link-vm" id="nav-p-biomec-tab" data-toggle="tab" href="#nav-p-biomec" role="tab" aria-controls="nav-p-biomec" aria-selected="false">Peligro Biomecánico</a>
                                <a class="flex-sm-fill text-sm-center nav-link-vm" id="nav-p-cds-tab" data-toggle="tab" href="#nav-p-cds" role="tab" aria-controls="nav-p-cds" aria-selected="false">Peligro por Condiciones de Seguridad</a>
                            </div>
                        </nav>
                        <div class="tab-content" id="nav-tabContent">
                            <div class="tab-pane fade show active" style="height: 100% !important;" id="nav-p-bio" role="tabpanel" aria-labelledby="nav-p-bio-tab">
                                <div style="height: 50% !important">
                                    <h3 class="title-dangers">Peligro Biológico</h3>
                                    <p class="descrp-dangers">
                                        El riesgo biológico consiste en la presencia de un organismo, o la sustancia derivada de un organismo, que plantea, sobre todo, 
                                        una amenaza a la salud humana (una contaminación biológica). Esto puede incluir los residuos sanitarios, muestras de un microorganismo, 
                                        virus o toxina de una fuente biológica que puede resultar patógena. Puede también incluir las sustancias dañinas a los animales y 
                                        otros seres vivos.
                                    </p>
                                    <p class="descrp-dangers">
                                        Las actividades laborales donde existe la mayor posibilidad de encontrar trabajadores expuestos a los riesgos biológicos son: Entidades de salud, 
                                        laboratorios clínicos, biológicos, cría y manejo de animales, manejo de pieles y otros productos animales, procesamiento de carnes, 
                                        servicios funerarios, manipulación de residuos entre otros.
                                    </p>
                                    <p class="descrp-dangers">
                                        Los principales mecanismos por los que un microorganismo penetra en un individuo son inhalación, ingestión y contacto dérmico.
                                    </p>
                                </div>

                                <div style="height: 50% !important;" class="row">
                                    <div class="table-height overflow-auto">                                
                                        <table class="table table-striped">
                                            <tbody>
                                                <tr>
                                                    <td class="title-subcla">Virus</td>
                                                    <td class="text-muted">
                                                        <p>
                                                            Agente infeccioso microscópico que solo puede multiplicarse dentro de las células de otros organismos.
                                                        </p>
                                                        <p>
                                                            Los virus infectan todos los tipos de organismos, desde animales y plantas, hasta bacterias y arqueas.
                                                        </p>
                                                        <p>
                                                            Ejemplos de enfermedades humanas comunes provocadas por virus incluyen el resfriado, la gripe, la varicela y el herpes simple. Así como enfermedades graves tales como el ébola, 
                                                            el sida, la gripe aviar y el SARS son causadas por virus.
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="title-subcla">Bacterias</td>
                                                    <td class="text-muted">
                                                        <p>
                                                            Microorganismos que presentan un tamaño de unos pocos micrómetros y diversas formas incluyendo filamentos, esferas (cocos), barras (bacilos), sacacorchos (vibrios) y hélices (espirilos).
                                                        </p>
                                                        <p>
                                                            Solo una pequeña fracción de las bacterias causan enfermedades en los seres humanos. Son una de las principales causas de enfermedad y mortalidad humana, 
                                                            causando infecciones tales como el tétanos, la fiebre tifoidea, la difteria, la sífilis, el cólera, intoxicaciones alimentarias, la lepra y la tuberculosis.
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="title-subcla">Hongos</td>
                                                    <td class="text-muted">
                                                        <p>
                                                            Son formas complejas de vida que presentan una estructura vegetal. Su hábitat natural es el suelo, 
                                                            pero algunos son parásitos tanto de animales como de vegetales, ya que no pueden sintetizar proteínas por sí solos. 
                                                            Producen principalmente enfermedades micóticas (pie de atleta), asma, etc. Se manifiestan principalmente a través de la piel.
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="title-subcla">Parásitos</td>
                                                    <td class="text-muted">
                                                        <p>
                                                            Tipo de simbiosis en la que existe una estrecha relación en la cual uno de los participantes, 
                                                            (el parásito o huésped) depende del otro (hospedador o anfitrión) y obtiene algún beneficio; lo cual implica daño para el anfitrión.
                                                        </p>
                                                        <p>
                                                            Ocasionan enfermedades como la malaria, tripanosomiasis africana, giardiasis, esquistosomiasis, fascioliasis entre otras.
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="title-subcla">Rackettsias</td>
                                                    <td class="text-muted">
                                                        <p>
                                                            Pequeñas bacterias del filo de las proteobacterias.
                                                        </p>
                                                        <p>
                                                            Según la distribución de las rickettsias se puede producir neumonitis intersticial, miopericarditis, lesiones vasculíticas cutáneas, 
                                                            meningitis linfocitaria, así como afectación hepática, renal y gastrointestinal.
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="title-subcla">Picaduras</td>
                                                    <td class="text-muted">
                                                        <p>
                                                            Las picaduras son pequeñas heridas punzantes producidas principalmente por insectos, 
                                                            artrópodos y animales marinos a través de las cuales inyectan sustancias tóxicas que actúan localmente y en forma sistemática (en todo el cuerpo) de acuerdo con la clase de agente causante, 
                                                            la cantidad de tóxico y la respuesta orgánica
                                                        </p>
                                                        <p>
                                                            Pueden producir desde reacciones alérgicas hasta la muerte.
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="title-subcla">Mordedura</td>
                                                    <td class="text-muted">
                                                        <p>
                                                            Situación generada por animales como serpientes, perros, gatos y monos entre otros. El problema de este tipo de lesiones no es en si la herida que provocan, 
                                                            sino la grave infección que pueden desencadenar.
                                                        </p>
                                                        <p>
                                                            Las consecuencias para la salud humana dependerán de la especie animal de que se trate y su estado de salud, 
                                                            el tamaño y el estado de salud de la víctima de la mordedura, y la capacidad de acceder a la atención sanitaria adecuada.
                                                        </p>
                                                    </td>
                                                </tr><tr>
                                                    <td class="title-subcla">Fluidos o excrementos</td>
                                                    <td class="text-muted">
                                                        <p>
                                                            Aquellos materiales de origen humano, animal o vegetal consistentes entre otras cosas, en excretas, secreciones, 
                                                            sangre y sus componentes, tejidos y líquidos tisulares, que contienen microorganismos incluidas las bacterias, virus, parásitos, hongos entre otros.
                                                        </p>
                                                        <p>
                                                            Las consecuencias para la salud humana dependen de los microorganismos que contengan el fluido o el excremento pudiendo ocasionar hasta la muerte.
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                            <div class="tab-pane fade" id="nav-p-fisico" role="tabpanel" aria-labelledby="nav-p-fisico-tab">
                                <h3 class="title-dangers">Peligro Físico</h3>
                                <p class="descrp-dangers">
                                    Los factores de riesgo físico se refieren a todos aquellos factores ambientales que dependen de las propiedades físicas de los cuerpos, 
                                    tales como carga física, ruido, iluminación, radiación ionizante, radiación no ionizante, 
                                    temperaturas extremas y vibración, que actúan sobre los tejidos y órganos del cuerpo del trabajador y que pueden producir efectos nocivos, 
                                    de acuerdo con la intensidad y tiempo de exposición al mismos.
                                </p>
                                <div class="  table-height overflow-auto"> 
                                <table class="table table-striped">
                                    <tbody>
                                        <tr>
                                            <td class="title-subcla">Ruido</td>
                                            <td class="text-muted">
                                                <p>
                                                    El sonido es producido por la vibración de cuerpos o moléculas y dependiendo de la intensidad, la frecuencia o el timbre se pueden convertir en ruido generalmente molesto. 
                                                    Esta Presión sonora es medida en decibeles y es emitida por maquinas, equipos o elementos del entorno.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Ruido de impacto</td>
                                            <td class="text-muted">
                                                <p>
                                                    Es aquel en el que se presentan variaciones rápidas de un nivel de presión sonora en intervalos de tiempo menores. Ejemplo: el producido por los estampadores.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Ruido intermitente</td>
                                            <td class="text-muted">
                                                <p>
                                                    Es aquel en el cual se presentan subidas bruscas y repentinas de la intensidad sonora en forma periódica. Ejemplo: el accionar un taladro.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Ruido continuo</td>
                                            <td class="text-muted">
                                                <p>
                                                    Es aquel cuyos niveles de presión sonora no presenta oscilaciones y se mantiene relativamente constantes a través del tiempo. Ejemplo: ruido de un motor eléctrico.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Iluminación</td>
                                            <td class="text-muted">
                                                <p>
                                                    Cantidad de luminosidad presente en el sitio de trabajo de los colaboradores cuya finalidad es facilitar la visualización de los objetos y el área de trabajo. 
                                                    A mayor precisión requerida, mayor necesidad de iluminación.
                                                </p>
                                                <p>Fatiga visual, molestias oculares, pesadez de ojos, picores, necesidad de frotarse los ojos, somnolencia.</p>
                                                <p>Trastornos visuales.</p>
                                                <p>Borrosidad, disminución de la capacidad visual.</p>
                                                <p>Fatiga mental cefaleas, vértigos, ansiedad. </p>
                                                <p>Deslumbramientos.</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Vibración</td>
                                            <td class="text-muted">
                                                <p>Propagación de ondas elásticas, que producen deformaciones y tensiones sobre un medio continuo o punto de equilibrio.</p>
                                                <p>Se genera en presencia de máquinas en movimiento constante o con el uso de herramientas de perforación como taladros.</p>
                                                <p>
                                                    Dependiendo de la frecuencia del movimiento oscilatorio, y de su intensidad, la vibración puede causar sensaciones muy diversas 
                                                    que van desde el simple disconfort hasta alteraciones graves de la salud, pasando por la interferencia de la labor de ciertas tareas como la lectura, 
                                                    perdida de presión al ejecutar movimientos, o perdida de rendimiento debido a la fatiga.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Temperaturas extremas calor</td>
                                            <td class="text-muted">
                                                <p>
                                                    Se refiere a los cambios de temperatura extremas (muy alta o baja) que se generan en el entorno del colaborador 
                                                    los cuales se manifiestan en el aire y en los cuerpos en forma de calor, en una gradación que fluctúa entre lo caliente y lo frio.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Temperaturas extremas frío</td>
                                            <td class="text-muted">
                                                <p>Malestar general, disminución de destreza manual, congelación de los miembros, comportamiento extravagante, muerte por falla cardiaca.</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Presión atmosférica</td>
                                            <td class="text-muted">
                                                <p>
                                                    La presión atmosférica es la fuerza por unidad de superficie que ejerce el aire sobre la superficie terrestre. 
                                                    A grandes o bajas alturas respecto al nivel del mar se pueden producir efectos nocivos en la salud de los colaboradores.
                                                </p>
                                                <p>
                                                    Las altas o bajas presiones atmosféricas pueden afectar el oído, los senos paranasales, y los pulmones. 
                                                    Enfermedades típicas ocasionadas por la presión atmosférica son la barotitis, la barosinusitis y algunas afecciones pulmonares.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Radiaciones ionizantes</td>
                                            <td class="text-muted">
                                                <p>
                                                    La radiación ionizante es un tipo de energía liberada por los átomos en forma de ondas electromagnéticas o partículas.
                                                </p>
                                                <p>
                                                    La mayor exposición humana a la radiación proviene de fuentes artificiales que van desde la generación de energía nuclear 
                                                    hasta el uso médico de la radiación para fines diagnósticos o terapéuticos.
                                                </p>
                                                <p>
                                                    Las dosis bajas de radiación ionizante pueden aumentar el riesgo de efectos a largo plazo, tales como el cáncer.
                                                </p>
                                                <p>
                                                    Cuando las dosis de radiación superan determinados niveles pueden tener efectos agudos en la salud, tales como quemaduras cutáneas o síndrome de irradiación aguda.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Radiación no ionizante</td>
                                            <td class="text-muted">
                                                <p>
                                                    Se llama radiación no ionizante a toda energía en forma de ondas que se propagan a través del espacio.
                                                </p>
                                                <p>
                                                    Algunos ejemplos de radiación No Ionizante son la radiación ultravioleta, la luz visible, la radiación infrarroja, los campos de radiofrecuencias y microondas, 
                                                    los campos de frecuencias extremadamente bajas y los campos eléctricos y magnéticos estáticos.
                                                </p>
                                                <p>
                                                    Producen efectos biológicos, como calentamiento, alteración de las reacciones químicas o inducción de corrientes eléctricas en los tejidos y las células. 
                                                    La exposición continua puede causar cáncer.
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>

                            </div>
                            <div class="tab-pane fade" id="nav-p-quimico" role="tabpanel" aria-labelledby="nav-p-quimico-tab">
                                <h3 class="title-dangers">Peligro Químico</h3>
                                 <p class="descrp-dangers">
                                    Riesgo producido por una exposición no controlada a agentes químicos la cual puede producir efectos agudos o crónicos y la aparición de enfermedades. 
                                    Entran en contacto con el organismo, bien sea por inhalación, absorción o ingestión.
                                </p>

                                <div class="  table-height overflow-auto"> 
                                <table class="table table-striped">
                                    <tbody>
                                        <tr>
                                            <td class="title-subcla">Partículas orgánicos e inorgánicos</td>
                                            <td class="text-muted">
                                                <p>
                                                    Material sólido fino, orgánico o inorgánico, capaz de producir enfermedades que se agrupan bajo la denominación genérica de neumoconiosis.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Partículas tóxicas</td>
                                            <td class="text-muted">
                                                <p>
                                                    intoxicación aguda o crónica.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Polvos alérgicos</td>
                                            <td class="text-muted">
                                                <p>
                                                    asma, fiebre, dermatitis entre otras.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Polvos inertes</td>
                                            <td class="text-muted">
                                                <p>
                                                    disminución de la capacidad respiratoria.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Polvos fibrógenos</td>
                                            <td class="text-muted">
                                                <p>
                                                    fibrosis pulmonar o neumoconiosis.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Fibras</td>
                                            <td class="text-muted">
                                                <p>
                                                    Partículas alongadas cuya longitud es varias veces superior al diámetro. Las fibras respirables representan un riesgo para el sistema respiratorio.
                                                </p>
                                                <p>
                                                    Producen desde problemas respiratorios hasta problemas cancerígenos.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Líquidos (nieblas y rocíos)</td>
                                            <td class="text-muted">
                                                <p>
                                                    Gotas menudas que flotan en el aire las cuales han sido formadas por una condensación del estado gaseoso disgregando un líquido o por atomización, rocío o espumamiento.
                                                </p>
                                                <p>
                                                    Las consecuencias dependen del químico.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Gases y vapores</td>
                                            <td class="text-muted">
                                                <p>
                                                    Sustancias en forma gaseosa que normalmente se encuentran en estado líquido o sólido y que pueden ser 
                                                    tornadas a su estado original mediante un aumento de presión o disminución de la temperatura.
                                                </p>
                                                <p>
                                                    Las consecuencias dependen del químico.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Humos metálicos y no metálicos</td>
                                            <td class="text-muted">
                                                <p>
                                                    Aerosoles que se forman por condensación de vapores de sustancias que son sólidas a temperatura y 
                                                    presión ordinaria. Uno de los humos más comunes es el producido por la fundición de metales.
                                                </p>
                                                <p>
                                                    Las consecuencias dependen del químico.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Material particulado</td>
                                            <td class="text-muted">
                                                <p>
                                                    Mezcla heterogénea de partículas de diferentes tamaños y composición química. Es considerado como uno de los contaminantes del aire 
                                                    más importantes en términos de sus posibles efectos sobre la salud de las personas.
                                                </p>
                                                <p>
                                                    Afecciones respiratorias y cardiacas.
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>

                            </div>
                            <div class="tab-pane fade" id="nav-p-psico" role="tabpanel" aria-labelledby="nav-p-psico-tab">
                                <h3 class="title-dangers">Peligro Psicosocial</h3>
                                <p class="descrp-dangers">
                                    Riesgos relacionados con el medio ambiente laboral, la satisfacción en el trabajo, las capacidades, necesidades y expectativas del trabajador, 
                                    sus costumbres, sus condiciones personales y muchos otros, que pueden repercutir en la salud y el rendimiento del trabajador.
                                </p>
                                <p class="descrp-dangers">
                                    Los riesgos psicosociales perjudican la salud de los trabajadores y trabajadoras, 
                                    causando estrés y a largo plazo enfermedades cardiovasculares, respiratorias, inmunitarias, gastrointestinales, dermatológicas, 
                                    endocrinológicas, musculoesqueléticas y mentales. Son consecuencia de unas malas condiciones de trabajo, concretamente de una deficiente organización del trabajo.
                                </p>

                                <div class="  table-height overflow-auto"> 
                                <table class="table table-striped">
                                    <tbody>
                                        <tr>
                                            <td class="title-subcla">Gestión organizacional</td>
                                            <td class="text-muted">
                                                <p>
                                                    Aspectos propios de la administración del recurso humano como el estilo de mando, las modalidades de pago y de contratación, la participación, 
                                                    el acceso a actividades de inducción y capacitación, los servicios de bienestar social, los mecanismos de evaluación del desempeño y 
                                                    las estrategias para el manejo de los cambios que afecten a las personas, entre otros.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Características de la organización del trabajo</td>
                                            <td class="text-muted">
                                                <p>
                                                    Formas de comunicación, tecnología, modalidad de organización del trabajo y demandas cualitativas y cuantitativas de la labor.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Características del grupo social de trabajo</td>
                                            <td class="text-muted">
                                                <p>
                                                    Clima de relaciones, cohesión y calidad de las interacciones, así como el trabajo en equipo.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Condiciones de la tarea</td>
                                            <td class="text-muted">
                                                <p>
                                                    Demandas de carga mental (velocidad, complejidad, atención, minuciosidad, variedad y apremio de tiempo); 
                                                    el contenido mismo de la tarea que se define a través del nivel de responsabilidad directo (por bienes, por la seguridad de otros, por información confidencial, 
                                                    por vida y salud de otros, por dirección y por resultados); las demandas emocionales (por atención de clientes); especificación de los sistemas de control y definición de roles.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Interface persona tarea</td>
                                            <td class="text-muted">
                                                <p>
                                                    Pertinencia del conocimiento y habilidades que tiene la persona en relación con las demandas de la tarea, los niveles de iniciativa y 
                                                    autonomía que le son permitidos y el reconocimiento, así como la identificación de la persona con la tarea y con la organización.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Jornada de trabajo</td>
                                            <td class="text-muted">
                                                <p>
                                                    Información detallada por áreas y cargos de la empresa sobre duración de la jornada laboral; existencia o ausencia de pausas durante la jornada,
                                                    diferentes al tiempo para las comidas; trabajo nocturno; tipo y frecuencia de rotación de los turnos; número y frecuencia de las horas extras mensuales y 
                                                    duración y frecuencia de los descansos semanales.
                                                </p>
                                            </td>
                                        </tr>
                                    
                                    </tbody>
                                </table>
                                </div>

                            </div>
                            <div class="tab-pane fade" id="nav-p-biomec" role="tabpanel" aria-labelledby="nav-p-biomec-tab">
                                <h3 class="title-dangers">Peligro Biomecánico</h3>
                                <p class="descrp-dangers">
                                    Involucra todos aquellos agentes o situaciones que tienen que ver con la adecuación del trabajo, o los elementos de trabajo a la fisonomía humana.                                 
                                </p>

                                <div class="  table-height overflow-auto"> 
                                <table class="table table-striped">
                                    <tbody>
                                        <tr>
                                            <td class="title-subcla">Postura prolongada</td>
                                            <td class="text-muted">
                                                <p>
                                                    Mantenimiento de una misma postura principal a lo largo del 75% de la jornada laboral. (Labores de digitación).
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Postura mantenida</td>
                                            <td class="text-muted">
                                                <p>
                                                    Se refiere al mantenimiento de una misma postura sedente o bípeda durante periodo de 2 o más horas, (Posturas de cuclillas o de rodillas).
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Postura forzada</td>
                                            <td class="text-muted">
                                                <p>
                                                    Posición de trabajo que implica que el cuerpo deje de estar en una posición de confort para pasar a una posición 
                                                    forzada que puede implicar hiperextensiones, hiperflexiones y/o hiperrotaciones.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Postura antigravitacional</td>
                                            <td class="text-muted">
                                                <p>
                                                    Posicionamiento del tronco o de las extremidades en contra de la gravedad.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Esfuerzo</td>
                                            <td class="text-muted">
                                                <p>
                                                    El esfuerzo que el trabajador tiene que realizar para desarrollar la actividad laboral se denomina “carga de trabajo”. 
                                                    Cuando la carga de trabajo sobrepasa la capacidad del trabajador se pueden producir sobrecargas y fatiga.
                                                </p>
                                                <p>Lesiones musculo esqueléticas.</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Movimiento repetitivo</td>
                                            <td class="text-muted">
                                                <p>
                                                    Grupo de movimientos continuos mantenidos durante un trabajo que implica la acción conjunta de los músculos, 
                                                    los huesos, las articulaciones y los nervios de una parte del cuerpo y provoca en esta misma zona fatiga muscular, sobrecarga, dolor y, por último, lesión.
                                                </p>
                                                <p>
                                                    Lesiones musculo esqueléticas.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Manipulación manual de cargas</td>
                                            <td class="text-muted">
                                                 <p>
                                                    Toda manipulación que incluya levantamiento, descenso, transporte, tracción o empuje de objetos pesados.
                                                </p>
                                                <p>
                                                    Lesiones musculo esqueléticas.
                                                </p>
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                                </div>

                            </div>
                            <div class="tab-pane fade" id="nav-p-cds" role="tabpanel" aria-labelledby="nav-p-cds-tab">
                                <h3 class="title-dangers">Peligro por Condiciones de Seguridad</h3>
                                <p class="descrp-dangers">
                                    Son todos aquellos factores asociados a la labor que pueden dar lugar a situaciones indeseables y 
                                    que pueden por tanto causar daños a los trabajadores. Debidas a las máquinas y los equipos, las herramientas, 
                                    los espacios de trabajo, la manipulación y el transporte, los sistemas eléctricos entre otros.
                                </p>

                                <div class="  table-height overflow-auto"> 
                                <table class="table table-striped">
                                    <tbody>
                                        <tr>
                                            <td class="title-subcla">Mecánico</td>
                                            <td class="text-muted">
                                                <p>
                                                    Contempla todos los factores presentes en objetos, máquinas, equipos, herramientas, que pueden ocasionar accidentes laborales, 
                                                    por falta de mantenimiento preventivo y/o correctivo, carencia de guardas de seguridad en el sistema de transmisión de fuerza, 
                                                    punto de operación y partes móviles y salientes, falta de herramientas de trabajo y elementos de protección personal.
                                                </p>
                                                <p>
                                                    Laceraciones, aplastamientos, amputaciones, ingreso de cuerpos extraños a la vía ocular, traumas, quemaduras y en ciertos casos la muerte.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Eléctrico</td>
                                            <td class="text-muted">
                                                <p>
                                                    Se refiere a los sistemas eléctricos de las máquinas, equipos, herramientas e instalaciones locativas en general, que conducen o generan energía eléctrica.
                                                </p>
                                                <p>
                                                    Pueden provocar, entre otras lesiones, quemaduras, choque, fibrilación ventricular, según sea la intensidad de la corriente y el tiempo de contacto.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Locativo</td>
                                            <td class="text-muted">
                                                <p>
                                                    Se refiere a las características de diseño, construcción, mantenimiento y deterioro de las instalaciones 
                                                    locativas las cuales pueden ocasionar lesiones a los trabajadores o incomodidades para desarrollar la labor.
                                                </p>
                                                <p>
                                                    Tropezones, resbalones, caídas golpes por choque con equipos, escritorios, máquinas y otros, cortaduras, infecciones, alergias, picaduras, etc., por falta de orden y aseo.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Tecnológico</td>
                                            <td class="text-muted">
                                                <p>
                                                    Es la probabilidad de que un objeto, material o proceso peligroso, una sustancia tóxica o peligrosa o bien un fenómeno debido a la interacción de estos, 
                                                    ocasione un número determinado de consecuencias a la salud, la economía, el medio ambiente y el desarrollo integral de un sistema.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Accidente de tránsito</td>
                                            <td class="text-muted">
                                                <p>
                                                    Situaciones que pueden generar lesiones a las personas en las que se ven involucrados vehículos.
                                                </p>
                                                <p>
                                                    Accidentes de trabajo con potencial de causar la muerte de la persona.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Públicos</td>
                                            <td class="text-muted">
                                                <p>
                                                    Factor de riesgo derivado de situaciones de agresión intencional de seres humanos contra seres humanos, contra intereses privados de las personas, 
                                                    ó, contra algunas comunidades (actos delictivos), y en los que se vean involucrados trabajadores de manera directa o indirecta, 
                                                    y que produzcan lesiones generando una incapacidad temporal o permanente.
                                                </p>
                                                <p>
                                                    El riesgo público considera situaciones como robos, atracos, asaltos, atentados, de orden público etc.
                                                </p>
                                                <p>
                                                    Accidentes de trabajo con potencial de causar la muerte de la persona.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Trabajo en alturas</td>
                                            <td class="text-muted">
                                                <p>
                                                    Se refiere a los riesgos que genera toda actividad que se realice a más de un metro con cincuenta centímetros (1,5m) del nivel del suelo ya sea negativo o positivo.
                                                </p>
                                                <p>
                                                    Accidentes de trabajo con potencial de causar la muerte de la persona.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="title-subcla">Espacios confinados</td>
                                            <td class="text-muted">
                                                <p>
                                                    Se refiere a los riesgos asociados a la labor que se realiza en un espacio que por su diseño tiene un número limitado de aberturas de entrada y salida, 
                                                    cuenta con una ventilación natural desfavorable que podría contener o generar peligrosos contaminantes del aire, y no está destinado para una presencia continua de empleados.
                                                </p>
                                                <p>
                                                    Accidentes de trabajo con potencial de causar la muerte de la persona.
                                                </p>
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                                </div>

                            </div>
                        </div>
                        
                    </div>

                </div>
            </div>
        </div>

        <!-- MODAL MI PERFIL -->
        <div class="modal fade" id="modal_perfil" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
                <div class="modal-content container_admin">
                    <label class="dato ml-3"><b>Mi Perfil</b></label>
                    <div class="modal-body row">
                        <div class="col-md-6">
                            <label class="color_letra">Nombres</label>
                            <input v-model="c_nombre" type="text" class="form-control Mayus boton_texto" placeholder="Nombre Usuario." required>
                        </div>
                        <div class="col-md-6">
                            <label class="color_letra">Apellidos</label>
                            <input v-model="c_apellido" type="text" class="form-control Mayus boton_texto" placeholder="Apellido Usuario." required>
                        </div>
                        <div class="col-md-6  mt-4">
                            <label class="color_letra">N° de Identificación</label>
                            <input v-model="c_cedula" type="text" class="form-control Mayus boton_texto" placeholder="Cedula Usuario." required>
                        </div>
                        <div class="col-md-6  mt-4">
                            <label class="color_letra">Cargo</label>
                            <input v-model="c_cargo" type="text" class="form-control Mayus boton_texto" placeholder="Cargo Usuario." required>
                        </div>
                        <div class="col-md-6 mt-4">
                            <label class="color_letra">Correo</label>
                            <input v-model="c_correo" type="text" class="form-control boton_texto" placeholder="Correo Usuario." required>
                        </div>
                        <div class="col-md-6 mt-4">
                            <label class="color_letra">Número de Celular o Teléfono Fijo</label>
                            <input v-model="c_telefono" type="text" class="form-control Mayus boton_texto" placeholder="Telefono del Usuario." required>
                        </div>
                        <div class="col-md-3 mt-4">
                            <label class="color_letra">Estado</label>
                            <div v-if="c_estado == 0">
                                <button class="btn boton_copiado2">Activo</button>
                            </div>
                             <div v-if="c_estado == 1">
                                <button class="btn boton_copiado3">No Activo</button>
                            </div>
                        </div>
                        <div class="col-md-12 mt-4">
                            <label class="color_letra">PRIVILEGIOS</label>
                        </div>
                        <div class="col-md-12 mt-2 ">
                            <p>
                                <a class="btn btn-outline-secondary color_letra1" data-toggle="collapse" href="#privilegio_admin" role="button" aria-expanded="false" aria-controls="privilegio_admin">
                                    Administración
                                </a>
                            </p><br><br>
                            <div class="collapse" id="privilegio_admin">
                                <div class="card card-body">
                                    <div class="row">
                                        <div class="col-md-2"></div>
                                        <div class="col-md-3">
                                            <label class="color_letra">Registro Cliente</label>
                                                <p v-if="$store.state.global_privilegio_admin_registro_cliente.ver == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Ver
                                                </p><br>
                                                <p v-if="$store.state.global_privilegio_admin_registro_cliente.ver == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Ver
                                                </p><br><br>
                                                <p v-if="$store.state.global_privilegio_admin_registro_cliente.crear == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>Crear 
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_cliente.crear == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>Crear 
                                                </p><br><br>
                                                <p v-if="$store.state.global_privilegio_admin_registro_cliente.editar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-if="$store.state.global_privilegio_admin_registro_cliente.editar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-if="$store.state.global_privilegio_admin_registro_cliente.eliminar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                                <p v-if="$store.state.global_privilegio_admin_registro_cliente.eliminar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                        </div>
                                         <div class="col-md-3">
                                            <label class="color_letra">Registrar Usuario</label>
                                                <p v-show="$store.state.global_privilegio_admin_registro_usuario.ver == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Ver
                                                </p><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_usuario.ver == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Ver
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_usuario.crear == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Crear
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_usuario.crear == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Crear
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_usuario.editar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_usuario.editar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_usuario.eliminar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_usuario.eliminar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="color_letra">Registro Proceso</label>
                                                <p v-show="$store.state.global_privilegio_admin_registro_proceso.ver == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Ver
                                                </p><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_proceso.ver == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Ver
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_proceso.crear == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Crear
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_proceso.crear == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Crear
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_proceso.editar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_proceso.editar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_proceso.eliminar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_proceso.eliminar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                        </div>
                                        <div class="col-md-3 mt-4">
                                            <label class="color_letra">Registro Peligro</label>
                                                 <p v-show="$store.state.global_privilegio_admin_registro_peligro.ver == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Ver
                                                </p><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_peligro.ver == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Ver
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_peligro.crear == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Crear
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_peligro.crear == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Crear
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_peligro.editar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_peligro.editar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_peligro.eliminar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_peligro.eliminar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                        </div>
                                        <div class="col-md-3 mt-4">
                                            <label class="color_letra">Efectos Posibles</label>
                                                <p v-show="$store.state.global_privilegio_admin_registro_efecto_posible.ver == true" class="color_letra1">
                                                     <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Ver
                                                </p><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_efecto_posible.ver == false" class="color_letra1">
                                                     <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Ver
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_efecto_posible.crear == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Crear
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_efecto_posible.crear == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Crear
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_efecto_posible.editar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_efecto_posible.editar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_efecto_posible.eliminar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_efecto_posible.eliminar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                        </div>
                                        <div class="col-md-3 mt-4">
                                            <label class="color_letra">Control y media</label>
                                                <p v-show="$store.state.global_privilegio_admin_registro_control_medida.ver == true" class="color_letra1">
                                                     <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Ver
                                                </p><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_control_medida.ver == false" class="color_letra1">
                                                     <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Ver
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_control_medida.crear == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Crear
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_control_medida.crear == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Crear
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_control_medida.editar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_control_medida.editar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_control_medida.eliminar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_control_medida.eliminar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                        </div>
                                        <div class="col-md-3 mt-4">
                                            <label class="color_letra">Registro Región</label><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_regional.ver == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Ver
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_regional.ver == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Ver
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_regional.crear == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Crear
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_regional.crear == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Crear
                                                </p><br><br>
                                                <p v-show="$store.state.global_privilegio_admin_registro_regional.editar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_regional.editar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Editar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_regional.eliminar == true" class="color_letra1">
                                                    <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                                <p v-show="$store.state.global_privilegio_admin_registro_regional.eliminar == false" class="color_letra1">
                                                    <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                    Eliminar
                                                </p>
                                        </div>
                                    </div>
                                </div>
                            </div>                           
                        </div>
                        <div class="col-md-12">
                            <p>
                                <a class="btn btn-outline-secondary color_letra1" data-toggle="collapse" href="#privilegio_matriz" role="button" aria-expanded="false" aria-controls="privilegio_matriz">
                                    Matriz
                                </a>
                            </p><br><br>
                            <div class="collapse" id="privilegio_matriz">
                                <div class="card card-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label class="color_letra">Matriz de Peligros</label><br>
                                        </div>
                                        <div class="col-md-3">
                                            <p v-show="$store.state.global_privilegio_matriz_peligro.ver == true">
                                                <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                Ver
                                            </p>
                                            <p v-show="$store.state.global_privilegio_matriz_peligro.ver == false">
                                                <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                Ver
                                            </p>
                                        </div>
                                        <div class="col-md-3">
                                            <p v-show="$store.state.global_privilegio_matriz_peligro.crear == true">
                                                <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                Crear
                                            </p>
                                            <p v-show="$store.state.global_privilegio_matriz_peligro.crear == false">
                                                <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                Crear
                                            </p>
                                        </div>
                                        <div class="col-md-3">
                                            <p v-show="$store.state.global_privilegio_matriz_peligro.editar == true">
                                                <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                Editar
                                            </p>
                                            <p v-show="$store.state.global_privilegio_matriz_peligro.editar == false">
                                                <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                Editar
                                            </p>
                                        </div>
                                        <div class="col-md-3">
                                            <p v-show="$store.state.global_privilegio_matriz_peligro.eliminar == true">
                                                <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                Eliminar
                                            </p>
                                            <p v-show="$store.state.global_privilegio_matriz_peligro.eliminar == false">
                                                <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                Eliminar
                                            </p>
                                        </div>
                                        <div class="col-md-4">
                                            <p v-show="$store.state.global_privilegio_matriz_peligro.descargar_excel == true">
                                                <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                Descargar Excel
                                            </p>
                                            <p v-show="$store.state.global_privilegio_matriz_peligro.descargar_excel == false">
                                                <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                Descargar Excel
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p>
                                <a class="btn btn-outline-secondary color_letra1" data-toggle="collapse" href="#privilegio_consulta" role="button" aria-expanded="false" aria-controls="privilegio_consulta">
                                    Consulta
                                </a>
                            </p><br><br>
                            <div class="collapse" id="privilegio_consulta">
                                <div class="card card-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label class="color_letra">Consulta</label>
                                        </div>
                                        <div class="col-md-3">
                                            <p v-show="$store.state.global_privilegio_consulta.ver == true">
                                                <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                Ver
                                            </p>
                                            <p v-show="$store.state.global_privilegio_consulta.ver == false">
                                                <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                Ver
                                            </p>
                                        </div>
                                        <div class="col-md-3">
                                            <p v-show="$store.state.global_privilegio_consulta.pdf == true">
                                                <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                Descargar PDF
                                            </p>
                                            <p v-show="$store.state.global_privilegio_consulta.pdf == false">
                                                <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                Descargar PDF
                                            </p>
                                        </div>
                                        <div class="col-md-4">
                                            <p v-show="$store.state.global_privilegio_consulta.excel == true">
                                                <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                Descargar Excel
                                            </p>
                                            <p v-show="$store.state.global_privilegio_consulta.excel == false">
                                                <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                Descargar Excel
                                            </p>
                                        </div>
                                        <div class="col-md-2">
                                            <p v-show="c_fecha_inicial == '' "> 
                                                <i class="fa fa-toggle-off" aria-hidden="true"></i>
                                                Fecha
                                            </p>
                                        </div>
                                        <div class="col-md-2">
                                            <p v-show="c_fecha_inicial != '' "> 
                                                <i class="fa fa-toggle-on" aria-hidden="true"></i>
                                                Fecha <br>
                                                Desde {{c_fecha_inicial}}
                                                Hasta {{c_fecha_fin}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p>
                                <a class="btn btn-outline-secondary color_letra1" data-toggle="collapse" href="#privilegio_tipo_datos" role="button" aria-expanded="false" aria-controls="privilegio_tipo_datos">
                                    Tipo de Datos
                                </a>
                            </p><br><br>
                            <div class="collapse col-md-12" id="privilegio_tipo_datos">
                                <div class="card card-body">
                                    <div class="row ml-0">
                                        <div class="form-group col-md-12 table-responsive" v-for="(regional, index) in privilegio_regionales" :key="index">
                                            <table class="table table-bordered">
                                                <thead class="text-center text-light font-weight-bold" style="background-color: orange">
                                                    <th colspan="7">{{ regional }}</th>
                                                </thead>
                                                <tbody v-for="(departamentos, index) in privilegio_regional_departamentos" :key="index" v-if="departamentos.regional === regional">
                                                    <tr style="background-color: lightblue">
                                                        <td class="font-weight-bold">
                                                            Departamento
                                                        </td>
                                                        <td class="font-weight-bold">
                                                            Municipios
                                                        </td>
                                                    </tr>
                                                    <tr v-for="(municipios_departamento, index) in privilegio_regional_municipios" :key="index" v-if="municipios_departamento.departamento === departamentos.departamento" style="text-align: left">
                                                        <td>{{ departamentos.departamento }}</td>
                                                        <td>
                                                            <li v-for="(municipio, index) in municipios_departamento.municipios" :key="index">
                                                                {{ municipio }}
                                                            </li>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        <div class="col-md-12 mt-4">
                            <p>
                                <a class="btn btn-outline-secondary" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                                    Cambiar Contraseña
                                </a>
                            </p>
                            <div class="collapse" id="collapseExample">
                                <div class="card card-body">
                                    <label class="color_letra mt-3">Contraseña Anterior</label>
                                    <input v-model="contraseña_anterior" id="input_pass" type="password" class="form-control boton_texto">

                                    <label class="color_letra mt-3">Contraseña Nueva</label>                                
                                    <input type="password" class="form-control boton_texto">
                                </div>
                            </div>
                        </div>
                    
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn boton_cancelar" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn boton_guardar">Actualizar Datos</button>
                    </div>
                </div>  
            </div>
        </div>

    </div>  
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { db } from "./../firebase";

// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Traduccion from "./Traduccion/Traduccion.vue";
export default {
  name: "Navbar",

  components: {
    Traduccion
  },

  data() {
    return {
      movil_login: false,
      pc_login: false,

      // VARIABLES MI PERFIL
      c_nombre: "",
      c_apellido: "",
      c_cedula: "",
      c_cargo: "",
      c_correo: "",
      c_telefono: "",
      c_estado: "",
      c_fecha_inicial: "",
      c_fecha_fin: "",
      contraseña_anterior: "",
      id_regional: "",

      // VARIABLES REGIONALES
      privilegio_regionales: [],
      privilegio_regional_departamentos: [],
      privilegio_regional_municipios: [],
      regionales: null,
    };
  },
  created() {
    this.versionCeluApto();
  },
  methods: {
    hidemenu() {
      $("#sidebar-wrapper").toggleClass("toggled");
    },

    versionCeluApto() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // CONVERTIR PANTALLA A TAMAÑO CELULAR
      if (
        /windows phone/i.test(userAgent) ||
        /android/i.test(userAgent) ||
        (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
      ) {
        this.movil_login = true;
      } else {
        this.pc_login = true;
      }
    },

    cerrar_menu() {
      console.log("entro");
      $("#menu_").modal("hide");
    },

    modalIntroduccion() {
      $("#modalIntroduccion").carousel("pause");
    },

    modalPeligroBiologico() {
      $("#carouselControlsBiologico").carousel("pause");
    },

    modalPeligroFisico() {
      $("#carouselControlsFisico").carousel("pause");
    },

    modalPeligroQuimico() {
      $("#carouselControlsQuimico").carousel("pause");
    },

    modalPeligroPsico() {
      $("#carouselControlsPsico").carousel("pause");
    },

    modalPeligroBiomecanico() {
      $("#carouselControlsBiomecanico").carousel("pause");
    },

    modalPeligroPcs() {
      $("#carouselControlsPsc").carousel("pause");
    },

    fondo_naranja() {
      var body = document.getElementsByTagName("body")[0];
      body.style.backgroundImage = "url(img/fondos/fondo-naranja.jpg)";
      $("#wrapper").toggleClass("toggled");
    },

    fondo_blanco_naranja() {
      var body = document.getElementsByTagName("body")[0];
      body.style.backgroundImage = "url(img/fondos/fondo-blanco-naranja.png)";
      $("#wrapper").toggleClass("toggled");
    },

    fondo_blanco() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (
        /windows phone/i.test(userAgent) ||
        /android/i.test(userAgent) ||
        (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
      ) {
        var body = document.getElementsByTagName("body")[0];
        body.style.background = "#fff";
        $("#wrapper").toggleClass("toggled");
      } else {
        var body = document.getElementsByTagName("body")[0];
        body.style.backgroundImage = "url(img/fondos/fondo-blanco.png)";
        $("#wrapper").toggleClass("toggled");
      }
    },

    csv() {
      Swal.fire(
        "¡Buen trabajo!",
        "El archivo .CSV se descargó correctamente.",
        "success"
      );
    },

    // FUNCIÓN PARA CONSULTAR USUARIO
    async consultar() {
      NProgress.start();
      let docRef = await db.collection("usuarios").doc(this.$store.state.id);
      docRef.get().then((doc) => {
        if (doc.exists) {
          this.c_key = doc.id;
          this.c_nombre = doc.data().u_nombre_usuario;
          this.c_apellido = doc.data().u_apellido;
          this.c_cedula = doc.data().u_cedula;
          this.c_cargo = doc.data().u_cargo;
          this.c_correo = doc.data().u_correo;
          this.c_telefono = doc.data().u_telefono;
          this.c_estado = doc.data().u_estado;
          this.c_fecha_inicial = doc.data().u_rango_fecha_inicio;
          this.c_fecha_fin = doc.data().u_rango_fecha_fin;
        }
        $("#modal_perfil").modal("show");
      });

      let regionalesCollection =
        "usuarios/" + this.$store.state.id + "/u_test_regional";
      let regionales = db.collection(regionalesCollection);
      let allRegionales = await regionales.get();
      this.privilegio_regionales = [];
      this.privilegio_regional_departamentos = [];
      this.privilegio_regional_municipios = [];
      for (let doc of allRegionales.docs) {
        let departamentos = Object.values(doc.data().departamentos);
        this.privilegio_regionales.push(doc.data().nombre_regional);
        for (let departamento of departamentos) {
          this.privilegio_regional_departamentos.push({
            regional: doc.data().nombre_regional,
            departamento: departamento.nombre_departamento,
          });
          this.privilegio_regional_municipios.push({
            departamento: departamento.nombre_departamento,
            municipios: departamento.municipios,
          });
        }
      }
      NProgress.done();
      NProgress.remove();
    },

    cerrarsesion() {
      var body = document.getElementsByTagName("body")[0];
      body.style.backgroundImage = "url(img/fondos/fondo-blanco.png)";
      this.$router.replace("/");
      return;
    },
  },
};
</script>